module.exports = __webpack_public_path__ + "media/fr-clic2.e61b3dc9.mp3";